import {
  SET_POLL,
  SET_VOTE,
  DELETE_POLL,
  UPDATE_LIVE_DISCUSSION_POLLS,
} from '../mutation-types';

// TODO: Migrate to Poll Services
import liveDiscussionService from 'services/liveDiscussion';
import pollServices from 'services/liveDiscussion/polls';

import { EventBus } from 'utils/event-bus';

const handlePollError = (error) => {
  EventBus.$emit('toast-msg', error.response.data.message);
  return null;
};

export const setPoll = ({ commit }, payload) => {
  EventBus.$emit('close_poll', true);
  if (typeof payload === 'object') {
    payload.votes = [];
    commit(SET_POLL, payload);
    EventBus.$emit('new_poll', payload);
  } else {
    return liveDiscussionService.getPoll(payload)
      .then((res) => {
        const poll = res.data;
        poll.votes = [];
        commit(SET_POLL, poll);
        EventBus.$emit('new_poll', poll);
      })
      .catch((err) => {
        console.error(err);
      });
  }
};

export const unsetPoll = ({ commit }, payload) => {
  commit(DELETE_POLL, payload.id);
  EventBus.$emit('close_dialog_poll', true);
};

export const setVote = ({ commit }, payload) => {
  if (typeof payload === 'object') {
    const vote = payload;
    commit(SET_VOTE, vote);
  } else {
    const id = payload;
    return liveDiscussionService.getPollVote(id)
      .then((res) => {
        const vote = res.data;
        commit(SET_VOTE, vote);
      })
      .catch((err) => {
        console.error(err);
      });
  }
};


// sockets will update state;
export const createPoll = (
  { commit },
  { answers, discussion_id, question, status }
) => {
  return liveDiscussionService
    .createPoll({ discussion_id, question, answers, status })
    .then(({ data }) => {
      commit(SET_POLL, data);
      return data;
    })
    .catch(handlePollError);
};

export const deletePoll = (_, poll_id) =>
  liveDiscussionService
    .deletePoll(poll_id)
    .catch(handlePollError);

export const getAllPolls = ({ commit }, live_discussion_id) =>
  liveDiscussionService
    .getAllPolls(live_discussion_id)
    .then(({ data }) => commit(UPDATE_LIVE_DISCUSSION_POLLS, data))
    .catch(handlePollError);

export const voteOnPoll = (context, { poll_id, vote }) =>
  liveDiscussionService.votePoll(poll_id, vote).catch(handlePollError);

export const editPoll = ({ commit }, { poll_id, payload }) => {
  return pollServices.editPoll(poll_id, payload).then(({ data }) => {
    commit(SET_POLL, data);
    return data;
  });
};



// WEBPACK FOOTER //
// ./src/app/store/actions/polls.js